<ng-template #cardModal let-modal>
		<div class="modal-header">
		<h4 class="modal-title" id="modal-title" >Select Reward</h4>
		<button type="button" mat-icon-button aria-label="Close" (click)="modal.dismiss('Cross click')">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header">
				<div class="row">
				<div class="col-sm-4">Available Points: {{pointtotal - pending}} </div><div class="col-sm-8 text-right" color="purple"><span class="text-right" *ngIf="pending > 0" style="color:mediumpurple;font-weight:bold"> {{pending}} already on order </span></div>
				</div>
				</div>
				<div class="card-body text-center">
				<div *ngIf="rewards && rewards.length > 0">
					<div class="row" *ngFor="let reward of rewards">
					<div class="col-sm-3">
						<button class="btn-sm btn-primary" mat-raised-button [disabled]="reward.canselect === false" (click)="chooseReward(reward)">{{reward.rewardtype}}</button>
					</div>
					<div class="col-sm-3">
						{{reward.pointvalue}}
					</div>
					<div class="col-sm-6">
						{{reward.nicedesc}}
					</div>
					</div>
				</div>
				<div *ngIf="!rewards || rewards.length === 0" class="text-center p-4">
					<p class="text-muted">No rewards available</p>
				</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">		
	</div>
</ng-template>

<button mat-raised-button color="primary" (click)="gcModal()" *ngIf="pointtotal > 0">{{ pointtotal }} Reward Points </button>